import { LegacyMediaKeyError, UnresolvableMediaKeyError } from './errors';

/**
 * TRIL-628: the user-facing copy for a failed image delete, shared by web and mobile.
 *
 * The strings were byte-identical on both surfaces. Duplicated copy drifts silently — one surface
 * gets corrected and the other keeps telling people something that is no longer true — and this
 * whole ticket family exists because the product told people an image was gone when it was not.
 *
 * Each branch says ONLY what is true:
 *  - a legacy key can never be deleted by anyone, so it does not advise a retry;
 *  - an unresolvable url means storage was never contacted, so "could not be deleted from storage"
 *    would be false and a retry would re-run the same parse and fail identically.
 */
export const mediaDeleteMessage = (error: unknown): string => {
  if (error instanceof LegacyMediaKeyError) {
    return 'This image was uploaded before we tracked image ownership, so it cannot be deleted automatically.';
  }
  if (error instanceof UnresolvableMediaKeyError) {
    return 'We could not identify the stored file for that image, so it was not deleted. It may still be accessible.';
  }
  return 'The image could not be deleted from storage. It may still be accessible — please try again.';
};
